export const getOfferTitle = (row) => {
  const offerCount = 'Offer #' + row?.OfferCount;

  return row?.LatestOfferIteration?.CounterParentId
    ? 'Counter-' + offerCount + '-' + row?.LatestOfferIteration?.IterationCount
    : offerCount;
};
